import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {DRAG_DROP_PASTE} from '@lexical/rich-text';
import {snackbarAtom} from 'atoms/snackbar';
import {handleFiles} from 'components/DSYS/editor/nodes/fileUploadUtil';
import {
  RICH_TEXT_MEDIA_UPLOAD_SIZE_LIMIT_BYTES,
  useRichTextMediaUpload,
} from 'components/DSYS/editor/plugins/MediaUploadContext';
import {t} from 'i18next';
import {useSetAtom} from 'jotai';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {useEffect} from 'react';

export const DragDropPastePlugin = () => {
  const setSnackbarMessage = useSetAtom(snackbarAtom);
  const [editor] = useLexicalComposerContext();
  const mediaUpload = useRichTextMediaUpload();
  const maxFileSizeBytes = mediaUpload.maxFileSizeBytes ?? RICH_TEXT_MEDIA_UPLOAD_SIZE_LIMIT_BYTES;

  useEffect(
    () =>
      editor.registerCommand(
        DRAG_DROP_PASTE,
        (files: File[]) => {
          const validFiles = files.filter((file) => file.size <= maxFileSizeBytes);

          if (validFiles.length !== files.length) {
            setSnackbarMessage({
              text: t('rich_text_upload_size_error'),
            });
          }

          handleFiles(validFiles, mediaUpload, editor);
          return true;
        },
        COMMAND_PRIORITY_LOW
      ),
    [editor, maxFileSizeBytes, mediaUpload, setSnackbarMessage]
  );

  return null;
};
